.WixBaseUiEnvironment2854476616__root{
    -st-states: madefor;
}

.WixBaseUiEnvironment2854476616__root.WixBaseUiEnvironment2854476616--madefor{
    --wbu-font-stack: var(--wix-font-stack);
    --wbu-font-weight-regular: var(--wix-font-weight-regular);
    --wbu-font-weight-medium: var(--wix-font-weight-medium);
    --wbu-font-weight-bold: var(--wix-font-weight-bold);
}

/* st-namespace-reference="../../../../src/util/WixBaseUiEnvironment/WixBaseUiEnvironment.st.css" */